module.exports = __webpack_public_path__ + "assets/img/s5-subtitle-4-afcb0373.png";